export const TwitterIcon = () => {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="w:6 h-6 opacity-80 transition-opacity duration-200 hover:opacity-100 lg:h-8 lg:w-8"
    >
      <g clipPath="url(#clip0_13926_5350)">
        <path d="M19.0443 13.5429L30.9571 0H28.1341L17.7903 11.7591L9.52875 0H0L12.4931 17.7818L0 31.9836H2.82309L13.7464 19.5656L22.4713 31.9836H32L19.0437 13.5429H19.0443ZM15.1777 17.9385L13.9119 16.1678L3.84029 2.07842H8.1764L16.3043 13.449L17.5701 15.2197L28.1355 29.9997H23.7994L15.1777 17.9391V17.9385Z"></path>
      </g>
    </svg>
  );
};
